import axiosInstance from "../../../api/axiosInstance";

let postSpace = async(props, user) => {
    return new Promise((resolve, reject) => {   
        let uri = process.env.REACT_APP_API + "/espacios/create/"+ user?.profile + "/" + user?.locale;
        axiosInstance.post(uri, props).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default postSpace